import { render, staticRenderFns } from "./ContactFull.vue?vue&type=template&id=f272fe00"
import script from "./ContactFull.vue?vue&type=script&lang=js"
export * from "./ContactFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports